import styled from 'styled-components';

import { gridSizes, media, textSizes } from 'utils/style';

import UserCard from './component';

export default styled(UserCard)`
  list-style: none;
  background-color: var(--white);
  padding: ${gridSizes('M')} 0px;
  border: 1px solid var(--grey300);
  border-left: none;
  border-right: none;
  border-top: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${media.lessThan('extraSmall')`
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;

    .edit-button {
      display: none;
    }
  `};

  &.first {
    border-top: 1px solid var(--grey300);
  }
  .hidden-action {
    visibility: hidden;
    margin: 8px;

  ${media.lessThan('extraSmall')`
    visibility: visible;
  `};
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(240, 242, 246, 0.5);

    .hidden-action {
        visibility: visible;
      }
    }
  }

  .name {
    color: var(--grey900);
    font-size: ${textSizes('L')};
  }
  .email,
  .phone {
    font-size: ${textSizes('M')};
    color: var(--grey700);
  }
  p {
    margin: ${gridSizes('XS')};
    margin-left: 16px;
  }

  .info {
    flex: 4;
  }

  .actions {
    flex: 6;
    align-items: center;
    justify-content: flex-end;
    display: flex;
    padding-right: 8px;

    button {
      background-color: #e0eaff;
      color: #002575;
      margin-right: 12px;
      .white {
        color: #002575;
        border: 1px solid #002575;
      }

      &:hover {
        background-color: #6797fe;
      }
    }


    button:last-child {
      margin-right: 0px;
    }

    span {
      text-transform: lowercase;
      &::first-letter {
        text-transform: capitalize;
      }
    }
  }

  .confirmed-tag {
    background-color: var(--accent100);
    color: var(--accent900);
    text-transform: 'lowercase';
    margin-right: 24px;
  }

  .resend-tag {
    height: 32px;
    border-radius: 4px;
  }
`;
